export default {
  inserted(el, binding, vnode) {
    el.classList.add('lancamento-limpavel')
    const select = vnode.componentInstance
    el._limparLancamento = event => {
      if (!select || select.disabled || !select.clearable || select.multiple || select.search || !['Backspace', 'Delete'].includes(event.key)) return
      if (!select.selectedValue?.length) return
      event.preventDefault(); event.stopImmediatePropagation()
      select.clearSelection(); select.search = ''; select.open = false
    }
    el.addEventListener('keydown', el._limparLancamento, true)
  },
  unbind(el) { el.removeEventListener('keydown', el._limparLancamento, true); delete el._limparLancamento }
}
